(function () {
  if (window.giftAddonCartInitialized) return;
  window.giftAddonCartInitialized = true;

  // GIFT ELIGIBILITY FILTER [ true | false]
  // ---if false = gift wrap all non-gift-wrap items
  // ---if true = gift wrap only items not tagged 'no-gift-addon'
  const ENABLE_GIFT_ELIGIBLE_FILTER = false;

  let activeGiftWrapUpdate = null;

  async function getCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Could not fetch cart');
    return response.json();
  }

  async function addGiftWrap(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }]
      })
    });
  }

  async function changeCartLine(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    });
  }

  async function updateGiftWrapAttribute(enabled) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          gift_wrap: enabled ? 'true' : ''
        }
      })
    });
  }

  function getAllNonGiftWrapQuantity(cart, giftVariantId) {
    return cart.items.reduce(function (total, item) {
      if (item.variant_id === giftVariantId) return total;
      return total + item.quantity;
    }, 0);
  }

  function getEligibleGiftWrapQuantityFromDOM(giftVariantId) {
    const countedKeys = new Set();

    return Array.from(document.querySelectorAll('[data-cart-item]')).reduce(function (total, itemEl) {
      const lineKey = itemEl.dataset.lineKey;
      const variantId = Number(itemEl.dataset.variantId);
      const quantity = Number(itemEl.dataset.quantity || 0);
      const isGiftEligible = itemEl.dataset.giftEligible === 'true';

      if (!lineKey || countedKeys.has(lineKey)) return total;
      if (!isGiftEligible) return total;
      if (variantId === giftVariantId) return total;

      countedKeys.add(lineKey);
      return total + quantity;
    }, 0);
  }

  function getGiftWrapQuantity(cart, giftVariantId) {
    return ENABLE_GIFT_ELIGIBLE_FILTER
      ? getEligibleGiftWrapQuantityFromDOM(giftVariantId)
      : getAllNonGiftWrapQuantity(cart, giftVariantId);
  }

  function findGiftWrapLine(cart, giftVariantId) {
    return cart.items.find(function (item) {
      return item.variant_id === giftVariantId;
    });
  }

  function getActiveGiftWrapCheckbox() {
    return document.querySelector('[data-gift-wrap-checkbox]:checked');
  }

  function setLoading(checkbox, isLoading) {
    const addon = checkbox.closest('[data-gift-addon]');
    if (addon) addon.classList.toggle('custom-loading', isLoading);
    checkbox.disabled = isLoading;
  }

  async function applyGiftWrapState(checkbox) {
    const giftVariantId = Number(checkbox.dataset.giftVariantId);
    if (!giftVariantId) return;

    const cart = await getCart();
    const giftWrapLine = findGiftWrapLine(cart, giftVariantId);
    const eligibleQty = getGiftWrapQuantity(cart, giftVariantId);

    if (checkbox.checked && eligibleQty > 0) {
      if (giftWrapLine) {
        await changeCartLine(giftWrapLine.key, eligibleQty);
      } else {
        await addGiftWrap(giftVariantId, eligibleQty);
      }

      await updateGiftWrapAttribute(true);
    } else {
      if (giftWrapLine) {
        await changeCartLine(giftWrapLine.key, 0);
      }

      await updateGiftWrapAttribute(false);
    }
  }

  async function syncGiftWrap(checkbox) {
    setLoading(checkbox, true);

    activeGiftWrapUpdate = (async function () {
      try {
        await applyGiftWrapState(checkbox);

        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
        } else if (typeof openCartDrawer === 'function') {
          openCartDrawer(true);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('Gift wrap update failed:', error);
        checkbox.checked = !checkbox.checked;
        alert('Gift wrap could not be updated. Please try again.');
      } finally {
        setLoading(checkbox, false);
        activeGiftWrapUpdate = null;
      }
    })();

    return activeGiftWrapUpdate;
  }

  async function syncGiftWrapBeforeCheckout() {
    if (activeGiftWrapUpdate) {
      await activeGiftWrapUpdate;
    }

    const checkbox = getActiveGiftWrapCheckbox();

    if (!checkbox) return;

    await applyGiftWrapState(checkbox);
  }

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('[data-gift-wrap-checkbox]');
    if (!checkbox) return;

    syncGiftWrap(checkbox);
  });

  document.addEventListener('click', async function (event) {
    const checkoutButton = event.target.closest('.cart-drawer-checkout-btn, [name="checkout"]');
    if (!checkoutButton) return;

    const checkedGiftBox = getActiveGiftWrapCheckbox();
    if (!checkedGiftBox) return;

    event.preventDefault();
    event.stopPropagation();

    checkoutButton.setAttribute('aria-busy', 'true');
    checkoutButton.classList.add('custom-loading');

    try {
      await syncGiftWrapBeforeCheckout();
    } catch (error) {
      console.error('Gift wrap checkout sync failed:', error);
    } finally {
      checkoutButton.removeAttribute('aria-busy');
      checkoutButton.classList.remove('custom-loading');
      window.location.href = '/checkout';
    }
  }, true);
})();